import api from "../../../../lib/api";
import { IBankCreate, IBankListSearch, IEditBankPayload } from "../../../../types/master/bankInterface";

export const createBankApi = async (data: IBankCreate) => {
  return await api.post(`/bank`, data);
};

export const getBankListApi = async (data: IBankListSearch) => {
  return await api.get(`/bank/${data.page}/${data.pageLimit}?search=${data?.search??""}`)
}

export const getBankDataByIdApi = async (id: number) => {
  return await api.get(`/bank/${id}`)
}

export const editBankDataByIdApi = async (payload: IEditBankPayload) => {
  return await api.put(`/bank/${payload.id}`, payload.data);
};